module.exports = __webpack_public_path__ + "img/review-slider-yuri.98d58b47.webp";